import * as React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { UserGroups } from '../../../entities/auth/constants';
import { IState } from '../../../store/reducer';
import { withAuthentication } from './Auth';

interface IAdminAccessHocProps {
	isAdmin: boolean;
}

export const withAdminOnly = (WrappedComponent: React.ComponentType<React.PropsWithChildren<any>>) => {
	const mapStateToProps = (state: IState) => ({
		isAdmin: (state.entities.auth.session.current.groups || []).includes(UserGroups.ADMIN)
	});

	class AdminAccessHoc extends React.Component<IAdminAccessHocProps> {
		public render() {
			if (this.props.isAdmin) {
				return <WrappedComponent {...this.props} />;
			} else {
				return <Navigate to="/" />;
			}
		}
	}

	return withAuthentication(connect(mapStateToProps)(AdminAccessHoc));
};
